"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // eslint-disable-next-line import/prefer-default-export

var translateSelector = exports.translateSelector = function translateSelector(state) {
  return state.translate;
};